import { CwUtils } from '../../../../cw-utils/cw-utils.service';

import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, Occupation, PageOptions } from 'cw-backend';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class OccupationListProvider implements Resolve<any> {
    occupation: Occupation[];
    occupationEdit: Occupation;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.occupationEdit = this.state?.currentOccupation;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Occupation> {
        if (!id) {
            return null;
        }
        return this.gw.get('occupation/:id', { id: id });
    }

    get currentOccupation(): Occupation {
        return this.occupationEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('occupation/').subscribe((res: HttpResponse<any>) => {
                this.occupation = res.body;
                this.onDataChanged.next(this.occupation);
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions, entity?: String): Promise<any> {
        let urlPath = 'occupation/search';
        if (entity) {
            urlPath = entity + urlPath
        }
        return new Promise((resolve, reject) => {
            this.gw.post(urlPath, pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.occupation, res.body.content) && res.body.content.length > 0) {
                    this.occupation = res.body.content;
                    this.onDataChanged.next(this.occupation);
                } else {
                    this.occupation = res.body.content;

                }
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

